export default class AddToCartTrackingDataBuilder{

    build(product, location) {
        
        return {
            currencyCode: window.gtmeecom?.currencyCode || '',
            add: {
                actionField: {
                    list: location
                },
                products: [product]
            }
        }
    }
}